import { UpdateWinLossCommand } from "slotworks/commands/autoplay/update-win-loss-command";
import CloseRequestPayload from "slotworks/model/gameplay/requests/close-request-payload";
import CommsManager from "slotworks/server/comms-manager";

export function CloseCommand() {
    UpdateWinLossCommand();

    return CommsManager.request(new CloseRequestPayload());
}



// WEBPACK FOOTER //
// ./~/slotworks/commands/comms/close-command.ts